import React, { useEffect, useState } from "react";
import ReactImageMagnify from "react-image-magnify";
import ReactStars from "react-rating-stars-component";
import { useParams } from "react-router-dom";

const ShoppingCart = () => {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const REACT_APP_LIVE_DOMAIN_URL = process.env.REACT_APP_LIVE_DOMAIN_URL;
  const { id } = useParams();
  const [offerDetail, setOfferDetail] = useState(null);
  const [selectedImage, setSelectedImage] = useState(
    offerDetail?.productImages[0]
  );
  const [selectedSize, setSelectedSize] = useState(offerDetail?.sizes[0]);
  const [quantity, setQuantity] = useState(1);
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  useEffect(() => {
    const fetchOfferDetail = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}SalesOffers/detail/${id}`);
        if (!response.ok) throw new Error("Failed to fetch offer details");
        const data = await response.json();
        const img = data?.productImages[0];
        setSelectedImage(
          `${REACT_APP_LIVE_DOMAIN_URL}ExternalImages/MarketPlace${img}`
        );
        setOfferDetail(data);
        console.log("Offer detail:", data);
      } catch (error) {
        console.error("Error fetching detail:", error);
      }
    };

    if (id) {
      fetchOfferDetail();
    }
  }, [id]);

  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const userId = localStorage.getItem("userId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const handleAddToCart = () => {
    alert(
      `Added to cart:\nProduct: ${offerDetail.itemName}\nSize: ${selectedSize}\nQuantity: ${quantity}`
    );
  };

  // const submitReview = () => {
  //   alert(`Submitted Review:\nRating: ${rating} stars\nComment: ${reviewText}`);
  //   setRating(0);
  //   setReviewText("");
  // };

  return (
    <div className="container my-4">
      <div className="row g-3">
        {/* Left Side - Images */}
        <div className="col-md-6">
          <div className="card h-100">
            <div className="card-body d-flex">
              <div className="d-flex flex-column me-3">
                {offerDetail?.productImages.map((img, i) => (
                  <img
                    key={i}
                    src={`${REACT_APP_LIVE_DOMAIN_URL}ExternalImages/MarketPlace${img}`}
                    alt=""
                    onClick={() =>
                      setSelectedImage(
                        `${REACT_APP_LIVE_DOMAIN_URL}ExternalImages/MarketPlace${img}`
                      )
                    }
                    className={`mb-2 border ${
                      selectedImage === img
                        ? "border-primary"
                        : "border-secondary"
                    }`}
                    style={{
                      width: 100,
                      height: 100,
                      objectFit: "cover",
                      cursor: "pointer",
                      border: "5px solid",
                    }}
                  />
                ))}
              </div>
              <div style={{ width: "350px", height: "315px" }}>
                <ReactImageMagnify
                  {...{
                    smallImage: {
                      alt: "Product",
                      isFluidWidth: true,
                      src: selectedImage,
                      width: 350,
                      height: 315,
                      isFluidWidth: false,
                    },
                    largeImage: {
                      src: selectedImage,
                      width: 700,
                      height: 800,
                    },
                    enlargedImageContainerDimensions: {
                      width: "100%",
                      height: "100%",
                    },
                    enlargedImagePosition: "over",
                  }}
                  style={{ objectFit: "cover" }}
                />
              </div>
            </div>

            <div className="mt-auto px-4 py-2">
              <label className="form-label fw-bold">Product Description</label>
              <textarea
                className="form-control mb-3"
                rows="3"
                readOnly
                value={offerDetail?.productSummary || ""}
              />

              <label className="form-label fw-bold">Terms and Condtions</label>
              <textarea
                className="form-control"
                rows="2"
                readOnly
                value={offerDetail?.termsCondition || ""}
              />
            </div>
          </div>
        </div>

        {/* Right Side - Info & Actions */}
        <div className="col-md-6">
          <div className="card h-100">
            <div className="card-body">
              <h3 className="card-title">{offerDetail?.itemName}</h3>

              <p>
                {offerDetail?.quantityAvailable > 0 ? (
                  <span className="text-success">In Stock</span>
                ) : (
                  <span className="text-danger">Out of Stock</span>
                )}
              </p>
              <h3 className="text-black">Rs.{offerDetail?.netSellingAmount}</h3>
              <span style={{ fontSize: "13px" }}>
                Shipping calculated at checkout.
              </span>
              <br />

              <div
                style={{
                  backgroundColor: "#006A4E",
                  color: "white",
                  padding: "3px 10px",

                  display: "inline-block",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginTop: "10px",
                }}
              >
                Hurry, Only {offerDetail?.quantityAvailable} left!
              </div>

              <div style={{ marginTop: "10px" }} className="mb-2">
                <label
                  className="form-label mb-1"
                  style={{
                    color: "black",
                    fontSize: "12px",
                    fontWeight: "500",
                    textTransform: "none",
                  }}
                >
                  Size: <span style={{ color: "black" }}>{selectedSize}</span>
                </label>
                <div
                  style={{ marginTop: "10px" }}
                  className="d-flex flex-wrap gap-2"
                >
                  {offerDetail?.sizes.map((size, idx) => (
                    <button
                      key={idx}
                      type="button"
                      className={`btn btn-sm ${
                        selectedSize === size ? "" : "btn-outline-secondary"
                      }`}
                      style={{
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        fontSize: "14px",
                        borderRadius: "6px",
                        backgroundColor:
                          selectedSize === size ? "black" : "#EEEEEE",
                        color: selectedSize === size ? "white" : "black",
                        border: "1px solid #ccc",
                      }}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>

              <div
                style={{ marginTop: "20px" }}
                className="mb-3 d-flex align-items-center gap-2"
              >
                {/* Quantity Controls */}
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      setQuantity((prev) => Math.max(1, parseInt(prev) - 1))
                    }
                    style={{ width: "36px", height: "36px", padding: 0 }}
                  >
                    –
                  </button>

                  <input
                    type="number"
                    className="form-control text-center"
                    value={quantity}
                    min={1}
                    max={offerDetail?.stock || 999}
                    onChange={(e) => {
                      const val = parseInt(e.target.value) || 1;
                      if (
                        !isNaN(val) &&
                        val >= 1 &&
                        val <= offerDetail?.stock
                      ) {
                        setQuantity(val);
                      }
                    }}
                    style={{ width: "60px", height: "36px" }}
                  />

                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() =>
                      setQuantity((prev) =>
                        Math.min(offerDetail?.stock || 999, parseInt(prev) + 1)
                      )
                    }
                    style={{ width: "36px", height: "36px", padding: 0 }}
                  >
                    +
                  </button>
                </div>

                {/* Add to Cart Button */}
                <button
                  className="btn"
                  style={{
                    flex: 1, // take remaining space
                    height: "36px",
                    border: "1px solid black",
                    color: "black",
                    backgroundColor: "white",
                    fontWeight: "500",
                  }}
                  onClick={handleAddToCart}
                >
                  Add to Cart
                </button>
              </div>

              {/* Review Section */}

              {/* <div className="mt-4">
                <h5>Leave a Review</h5>
                <ReactStars
                  count={5}
                  onChange={(newRating) => setRating(newRating)}
                  size={30}
                  activeColor="#ffd700"
                  value={rating}
                />
                <textarea
                  className="form-control mt-2"
                  rows="4"
                  placeholder="Write your review..."
                  value={reviewText}
                  onChange={(e) => setReviewText(e.target.value)}
                ></textarea>
                <button className="btn btn-dark mt-2" onClick={submitReview}>
                  Submit Review
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCart;
